import { create } from 'zustand';

interface CompetitorFilter {
  filterType: string;
  filterValue: any;
}

interface CompetitorFiltersState {
  competitorFilters: CompetitorFilter[];
  addCompetitorFilter: (filter: CompetitorFilter) => void;
  clearCompetitorFilters: () => void;
}

export const useCompetitorFiltersStore = create<CompetitorFiltersState>(set => ({
  competitorFilters: [],
  addCompetitorFilter: filter =>
    set(state => ({
      competitorFilters: [...state.competitorFilters, filter],
    })),
  clearCompetitorFilters: () => set({ competitorFilters: [] }),
}));
